/**
 * Проверяет, есть ли у пользователя необходимое право.
 * @param credentials - Массив прав пользователя.
 * @param requiredPermission - Необходимое право.
 * @returns true, если у пользователя есть необходимое право, иначе false.
 */
export const hasPermissionForElementPage = (credentials: string[], requiredPermission: string): boolean => {
    return credentials.includes(requiredPermission);
};